import { render, staticRenderFns } from "./PanelList.vue?vue&type=template&id=7b4593cc&scoped=true&xmlns%3Ael-col=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./PanelList.vue?vue&type=script&lang=js"
export * from "./PanelList.vue?vue&type=script&lang=js"
import style0 from "./PanelList.vue?vue&type=style&index=0&id=7b4593cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4593cc",
  null
  
)

export default component.exports